import { venueMockData } from "./mock/venueData";

export const getDataByAll = () => {
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve(venueMockData);
    }, 500);
  });
};